"use client"

import type React from "react"
import { Loader2, MessageCircle } from "lucide-react"

interface LoadingDataProps {
  t: (key: string) => string
}

export const LoadingData: React.FC<LoadingDataProps> = ({ t }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full p-8">
      <div className="relative">
        <MessageCircle className="h-16 w-16 text-gray-300" strokeWidth={1} />
      </div>
      <div className="mt-6 text-center">
        <h3 className="text-lg font-medium text-gray-900 mb-2">{t("loading_conversation")}</h3>
        <p className="text-sm text-gray-500 max-w-sm">{t("loading_conversation_description")}</p>
      </div>
      <div className="mt-4 flex space-x-1">
        <div className="w-2 h-2 bg-[#105BDB] rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
        <div className="w-2 h-2 bg-[#105BDB] rounded-full animate-bounce" style={{ animationDelay: "100ms" }} />
        <div className="w-2 h-2 bg-[#105BDB] rounded-full animate-bounce" style={{ animationDelay: "200ms" }} />
      </div>
    </div>
  )
}
